import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { useAuthSignIn } from '@entities/auth/hooks/useSignIn';
import { setSurferWelcomePending } from '@entities/auth';
import { authApi } from '../../authApi';
import type {
  SurferRegisterRequest,
  SurferRegisterResponse,
} from '../../types';

export const useSurferRegister = (): UseMutationResult<
  SurferRegisterResponse,
  AxiosError<TFormErrorResponse>,
  SurferRegisterRequest
> => {
  const signIn = useAuthSignIn();

  return useMutation({
    mutationKey: [MutationKey.AUTH_SURFER_REGISTER],
    mutationFn: (data: SurferRegisterRequest) => authApi.surferRegister(data),
    onSuccess: ({ data, meta }) => {
      setSurferWelcomePending();
      signIn({
        tokenExpiresIn: data.expiresIn,
        token: data.accessToken,
        tokenType: data.tokenType,
        refreshToken: data.refreshToken,
        ...meta.user,
      });
    },
  });
};
